import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';

/**
 * Public auth endpoints that must NOT receive a Bearer token
 * (stale tokens would interfere with credential / reset flows).
 * OTP verify/resend, logout, refresh, and reset-password DO need the token.
 */
const PUBLIC_AUTH_PATHS = [
  '/api/v1/auth/login',
  '/api/v1/auth/password-reset/request',
  '/api/v1/auth/password-reset/confirm',
  /** Emailed position-export token redeem — public, no JWT. */
  '/api/v1/position-exports/download-url',
];

/** Attaches Bearer token to API requests when a token is available. */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = auth.getAccessToken();
  const isApiRequest = req.url.startsWith(environment.apiBaseUrl);
  const isPublicAuth = PUBLIC_AUTH_PATHS.some(path => req.url.includes(path));

  // Skip non-API calls (e.g. direct S3 PUT to a presigned URL).
  if (!token || !isApiRequest || isPublicAuth) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    }),
  );
};
